const TOOLTIP_INJECTION_KEY = Symbol("elTooltip");

export { TOOLTIP_INJECTION_KEY };
//# sourceMappingURL=tokens.mjs.map
